"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIALOG_PADDING_TOP = exports.DIALOG_PADDING_BOTTOM = void 0;
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var DIALOG_PADDING_TOP = exports.DIALOG_PADDING_TOP = "calc(".concat(_js["default"].alias.spacing.hsmall, " + ").concat(_js["default"].alias.spacing.xsmall, ")");
var DIALOG_PADDING_BOTTOM = exports.DIALOG_PADDING_BOTTOM = _js["default"].alias.spacing.small;